import React, { useEffect, useState } from 'react'
import { GridBody, GridContainer, GridHeader, HeaderCell } from './style'
import MachineRow from '../MachineRow'
import axios from '../../../../config/axios'
import StageSelector from '../StageSelector'

const weekdays = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta']

const PlanningGrid = ({ stageId, onSelectStage }:any) => {
  const [ machines, setMachines ] = useState([])
  const params = {
    stageId
  }

  const moveProductionOrder = (serviceId:number, fromDay:string, toDay:string) => {
    const getDayNumber = (dayName:string) => weekdays.indexOf(dayName) + 1

    axios.patch(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/${serviceId}`,
      {
        productionDay: getDayNumber(toDay)
      }
    )
      .then((response) => {
        if(response.data) {
          setMachines((prevMachines:any) => 
            prevMachines.map((machine:any) => ({
              ...machine,
              services: machine.services.map((service:any) => 
                service.id === serviceId
                  ? { ...service, productionDay: getDayNumber(toDay) }
                  : service
              )
            }))
          )
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    setMachines([])
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/machines`, {
      params
    })
      .then((response) => {
        if(response.data) setMachines(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [stageId])

  return (
    <GridContainer>
      <GridHeader>
        <HeaderCell>
          <StageSelector 
            selectedStage={stageId}
            onSelectStage={onSelectStage}            
          />
        </HeaderCell>
        {weekdays.map(day => (
          <HeaderCell key={day}>{day}</HeaderCell>
        ))}
      </GridHeader>
      <GridBody>
        {machines.map((machine:any) => (
          <MachineRow 
            key={machine.id}
            machine={machine}
            weekdays={weekdays}
            moveProductionOrder={moveProductionOrder}
          />
        ))}
      </GridBody>
    </GridContainer>
  )
}

export default PlanningGrid
